import type { MerchantService } from '@shared/types/merchant'

interface ServiceGuardProps {
  /**
   * Retained so existing route definitions (`<ServiceGuard requiredService="pos">`)
   * keep type-checking. Enablement is now informational and does not block routes.
   */
  requiredService?: MerchantService
  children: React.ReactNode
}

/**
 * Renders its children for any authenticated user. Service enablement is
 * informational only and no longer blocks access to a merchant's own routes.
 */
export function ServiceGuard({ children }: ServiceGuardProps) {
  // Both bank and merchant users can reach their own routes. Service enablement
  // is informational only (surfaced in the Products menu and services page) and
  // must not block a logged-in merchant from navigating to their own pages —
  // gating routes by the shared enabledServices value repeatedly locked merchants
  // out of POS, Engagement, and other pages.
  return <>{children}</>
}
